module.exports = __webpack_public_path__ + "img/new years shrine visit iii.98b0616f.png";